import React, { useState } from 'react';
import PropTypes from 'prop-types';
import NewDesign from '..';
import { CommonIcons } from 'components/Icons';
import { SIZE_ICON } from 'consts/data';
import { motion, AnimatePresence } from 'framer-motion';

const propTypes = {
  title: PropTypes.string,
  renderAfterTitle: PropTypes.node,
  options: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
  }),
  isExpand: PropTypes.bool,
};

const ExpandCollapseText = ({ title = '', options = [], renderAfterTitle, ...props }) => {
  //! State
  const [isExpand, setExpand] = useState(props.isExpand);

  //! Function
  const toggle = () => {
    setExpand(!isExpand);
  };

  //! Render
  return (
    <div className='component:ExpandCollapseText expand-collapse-text'>
      <NewDesign.Typography component='h5' className='expand-collapse-text__title' onClick={toggle}>
        {isExpand ? (
          <CommonIcons.MinusSquare size={SIZE_ICON} />
        ) : (
          <CommonIcons.PlusSquare size={SIZE_ICON} />
        )}
        {title}
      </NewDesign.Typography>

      {renderAfterTitle}

      <AnimatePresence>
        {isExpand ? (
          <motion.div
            layout
            initial={{ opacity: 0, height: 0, marginTop: 0 }}
            animate={{ opacity: 1, height: 'auto', marginTop: 12 }}
            exit={{ opacity: 0, height: 0, marginTop: 0 }}
            className='expand-collapse-text__options'
          >
            {options.map((el) => {
              return (
                <NewDesign.Typography key={el.label} onClick={el.onClick}>
                  {el.label}
                  <CommonIcons.Collapse />
                </NewDesign.Typography>
              );
            })}
          </motion.div>
        ) : null}
      </AnimatePresence>
    </div>
  );
};

ExpandCollapseText.propTypes = propTypes;
export default React.memo(ExpandCollapseText);
